<!-- 
BARRA DE FILTRO E TOTALIZACAO DE LISTAS


PARAMETRO DE ENTRADA:

  params: {
      total: [
          { status: "", label: "", total: 0, qt: 0, perc: 0 }
      ],
      selectedStatus: ""
  }

-->

<template>

    <div class="row mb-2 other-device">
        <div class="col-md-12 col-12">
            <div class="row justify-content-md-center">
                <div class="filter-list col-md-12 col-12" :class="cols">
                    <div class="filter-list filter " v-for="(total,index) in params.total" :key="index" 
                        :class="{'active': selectedIndex === index}" @click="handleSelect(index)">
                        <div v-if="total.total"> 
                            <label class="lbl-edit w-100"> {{ total.label }} <span v-if="total.qt"> ({{ total.qt }}) </span> </label>
                            <span class="total">R$<strong> {{ total.total | format }} </strong></span>
                            <span class="badge badge-blue" v-if="total.perc">{{ total.perc | format }}% </span>
                        </div>
                        <div v-else>
                            <label class="lbl-edit"> {{ total.label }} </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { SysVars } from '../main';
import { formatValue } from '../shared/utils'

export default {
    props: {
        params: Object,
    },

    data () {
        return {
            selectedIndex: -1,
        }
    },

    computed: {
        cols: function () {
            if (!this.params || !this.params.total || !this.params.total.length) {
                return ''
            } else
            if (this.params.total.length == 2) {
                return 'filter-list-2col'
            } else
            if (this.params.total.length == 3) {
                return 'filter-list-3col'
            } else
            if (this.params.total.length == 4) {
                return 'filter-list-4col'
            } else
            if (this.params.total.length == 5) {
                return 'filter-list-5col'
            } else
            if (this.params.total.length == 6) {
                return 'filter-list-6col'
            }
        }

    },

    methods: {
        handleSelect(index) {
            //envia para o chamador o status selecionado
            console.log(this.selectedIndex)
            if (this.selectedIndex === index) {
                this.params.selectedStatus = ''
                this.selectedIndex = -1
            } else {
                this.selectedIndex = index
            }
            if (this.selectedIndex === -1) {
                this.$emit('select', '')
            }
            else {
                this.$emit('select', this.params.total[index].status)
            }
        },

    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },
    },

    created () {

    }
  
}
</script>

<style scoped>

.mobile-device {
    display: block;
}

.other-device {
    display: none;
}

@media (min-width: 768px) {
  .mobile-device {
      display: none;
  }
  .other-device {
      display: block;
  }
}

.filter-list .filter:first-child {
    /* -webkit-border-top-left-radius: 3px;
    -moz-border-radius-topleft: 3px;
    border-top-left-radius: 3px; */
    border-left: 1px solid #C9D3DD;
    padding-left: 6px;
}

.filter-list .filter {
    box-sizing: border-box;
    background-color: #fff;
    background-image: none;
    border-top: 1px solid #C9D3DD;
    border-bottom: 1px solid #C9D3DD;
    height: 100%;
    cursor: pointer;
    float: left;
    position: relative;
    border-right: 1px solid #C9D3DD;
    color: #7A7A7F;
    margin: 0;
    padding: 14px 7px 7px;
    text-align: center;
}

.filter-list.filter:hover {
    border-top: 2px solid #267da5;
    background-color: #25244711;
}

.filter-list.filter.active {
    border-top: 2px solid #267da5;
    background-color: #2524472f;
}

.filter-list-5col .filter {
    width: 20%;
}

.filter-list-4col .filter {
    width: 25%;
}

.filter-list-3col .filter {
    width: 33.33%;
}

.filter-list-10col .filter {
    width: 10%;
}

.filter-list strong {
    font-size: 20px;
    font-weight: 700;
}

.filter-list strong {
    /* color: red; */
}

</style>






// WEBPACK FOOTER //
// src/components/filter-list.vue